import { render, staticRenderFns } from "./practices.vue?vue&type=template&id=25335731&scoped=true&"
import script from "./practices.vue?vue&type=script&lang=js&"
export * from "./practices.vue?vue&type=script&lang=js&"
import style0 from "./practices.vue?vue&type=style&index=0&id=25335731&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25335731",
  null
  
)

export default component.exports